module.exports = __webpack_public_path__ + "img/bule.73dfaf47.png";